import axios from 'axios';
import apiConfig from '../api.config';

export default function uploadMailAttachments({ file, hotelId, chainId }) {
  const {
    host,
    URIs: { uploadMailAttachments },
  } = apiConfig;

  const uri = `${host}${uploadMailAttachments}`;

  const formData = new FormData();
  formData.append('file', file);
  formData.append('hotelId', hotelId);

  return axios
    .post(uri, formData)
    .then(res => {
      return res.data;
    })
    .catch(error => {
      console.error(error);
    });
}
